import {
  PieChartResponse,
  LineChartResponse,
  LoyaltyReportSummaryCard,
  OfferTrends,
  OfferPerformanceData,
  LocationsPerformanceData,
  LocationsTrends,
  OffersPerformanceSummary,
  GetAvailableOffersResponse,
} from '../reports-service.types';

export const brandPointsSummary: LoyaltyReportSummaryCard = {
  startingBalance: {
    value: 192076,
    comparisonNumber: 0.052,
    sparkLineData: [3, 2, 2, 5, 7, 2, 4, 6],
    cardType: 'number',
  },
  pointsEarned: {
    value: 123456,
    comparisonNumber: 0.052,
    sparkLineData: [3, 2, 2, 5, 7, 2, 4, 6],
    cardType: 'number',
  },
  pointsRedeemed: {
    value: 123456,
    comparisonNumber: 0.052,
    sparkLineData: [3, 2, 2, 5, 7, 2, 4, 6],
    cardType: 'number',
  },
  pointsExpired: {
    value: 123456,
    comparisonNumber: 0.052,
    sparkLineData: [3, 2, 2, 5, 7, 2, 4, 6],
    cardType: 'number',
  },
  endingBalance: {
    value: 198917,
    comparisonNumber: 0.052,
    sparkLineData: [3, 2, 2, 5, 7, 2, 4, 6],
    cardType: 'number',
  },
};

export const brandSummary: LoyaltyReportSummaryCard = {
  totalMembers: { value: 123456, comparisonNumber: 0.052, cardType: 'number' },
  activeMembers: { value: 123456, comparisonNumber: 0.052, cardType: 'number' },
  activeMembersPercent: {
    value: 0.51,
    comparisonNumber: -0.049,
    cardType: 'percent',
  },
  deletedAccounts: {
    value: 123456,
    comparisonNumber: 0.052,
    cardType: 'number',
  },
  loyaltySales: {
    value: 123456,
    comparisonNumber: 0.052,
    cardType: 'currency',
  },
  loyaltyContributionPercentOfSales: {
    value: 0.49,
    comparisonNumber: 0.052,
    cardType: 'percent',
  },
  loyaltyContributionPercentOfOrders: {
    value: 0.49,
    comparisonNumber: 0.052,
    cardType: 'percent',
  },
  loyaltyAverageOrder: {
    value: 123456,
    comparisonNumber: 0.052,
    cardType: 'currency',
  },
  membersWhoOrdered: {
    value: 17,
    comparisonNumber: -0.2273,
    cardType: 'number',
  },
  activityRateMembersWhoOrdered: {
    value: 0.0013,
    comparisonNumber: -0.0004,
    cardType: 'percent',
  },
};

export const locationsPerformanceSummary: LoyaltyReportSummaryCard = {
  loyaltyEarnOrders: {
    value: 0,
    comparisonNumber: 0.052,
    // sparkLineData: [0],
    cardType: 'number',
  },
  loyaltyBurnOrders: {
    value: 0,
    comparisonNumber: 0.052,
    // sparkLineData: [0],
    cardType: 'number',
  },
  loyaltyOrdersNetSales: {
    value: 0,
    comparisonNumber: 0.052,
    // sparkLineData: [0],
    cardType: 'number',
  },
  discountAmount: {
    value: 0,
    comparisonNumber: 0.052,
    // sparkLineData: [0],
    cardType: 'number',
  },
  activeMembers: {
    value: 0,
    comparisonNumber: 0.052,
    // sparkLineData: [0],
    cardType: 'number',
  },
};

export const locationsPerformanceData: LocationsPerformanceData = {
  paging: {
    total: 2,
    count: 2,
    totalPages: 1,
    currentPage: 0,
  },
  stores: [
    {
      locationId: 'Location 0',
      displayInfoTitle: 'Location 0',
      newMembers: '12',
      membersWhoOrdered: '12',
      deletedAccounts: '12',
      activeMembers: '12',
      activeMemberPercent: '16%',
      totalOrders: '12',
      loyaltyEarnOrders: '12',
      loyaltyBurnOrders: '12',
      loyaltyNetZeroOrders: '12',
      totalLoyaltyOrders: '12',
      loyaltyContribution: '12%',
      allOrdersNetSales: '$13',
      bonusEarnEvents: '22',
      loyaltyOrdersNetSales: '$13',
      loyaltySales: '$13',
      discountAmount: '$13',
      loyaltyContributionSalesPercent: '13%',
      loyaltyContributionOrdersPercent: '14%',
      loyaltyAverageCheck: '$14',
      mobileLoyaltyOrders: '14',
      mobileLoyaltyOrdersPercent: '14%',
      webLoyaltyOrders: '14',
      webLoyaltyOrdersPercent: '14%',
      scan2PayOrders: '14',
      scan2PayOrdersPercent: '14%',
      inStoreLoyaltyOrders: '15',
      inStoreLoyaltyOrdersPercent: '15%',
      otherLoyaltyOrders: '15',
      otherLoyaltyOrdersPercent: '15%',
      uniqueUserScan2Pay: '15',
      uniqueUserWeb: '15',
      uniqueUserApp: '15',
      uniqueUserInStore: '15',
      uniqueUserOther: '15',
    },
    {
      locationId: 'Location 1',
      displayInfoTitle: 'Location 1',
      newMembers: '12',
      membersWhoOrdered: '12',
      deletedAccounts: '12',
      activeMembers: '12',
      activeMemberPercent: '100%',
      totalOrders: '12',
      loyaltyEarnOrders: '12',
      loyaltyBurnOrders: '12',
      loyaltyNetZeroOrders: '12',
      totalLoyaltyOrders: '12',
      loyaltyContribution: '12%',
      allOrdersNetSales: '$13',
      bonusEarnEvents: '22',
      loyaltyOrdersNetSales: '$13',
      loyaltySales: '$13',
      discountAmount: '$13',
      loyaltyContributionSalesPercent: '13%',
      loyaltyContributionOrdersPercent: '14%',
      loyaltyAverageCheck: '$14',
      mobileLoyaltyOrders: '14',
      mobileLoyaltyOrdersPercent: '14%',
      webLoyaltyOrders: '14',
      webLoyaltyOrdersPercent: '14%',
      scan2PayOrders: '14',
      scan2PayOrdersPercent: '14%',
      inStoreLoyaltyOrders: '15',
      inStoreLoyaltyOrdersPercent: '15%',
      otherLoyaltyOrders: '15',
      otherLoyaltyOrdersPercent: '15%',
      uniqueUserScan2Pay: '15',
      uniqueUserWeb: '15',
      uniqueUserApp: '15',
      uniqueUserInStore: '15',
      uniqueUserOther: '15',
    },
    {
      locationId: 'Location 2',
      displayInfoTitle: 'Location 2',
      newMembers: '12',
      membersWhoOrdered: '12',
      deletedAccounts: '12',
      activeMembers: '12',
      activeMemberPercent: '116%',
      totalOrders: '12',
      loyaltyEarnOrders: '12',
      loyaltyBurnOrders: '12',
      loyaltyNetZeroOrders: '12',
      totalLoyaltyOrders: '12',
      loyaltyContribution: '12%',
      allOrdersNetSales: '$13',
      bonusEarnEvents: '22',
      loyaltyOrdersNetSales: '$13',
      loyaltySales: '$13',
      discountAmount: '$13',
      loyaltyContributionSalesPercent: '13%',
      loyaltyContributionOrdersPercent: '14%',
      loyaltyAverageCheck: '$14',
      mobileLoyaltyOrders: '14',
      mobileLoyaltyOrdersPercent: '14%',
      webLoyaltyOrders: '14',
      webLoyaltyOrdersPercent: '14%',
      scan2PayOrders: '14',
      scan2PayOrdersPercent: '14%',
      inStoreLoyaltyOrders: '15',
      inStoreLoyaltyOrdersPercent: '15%',
      otherLoyaltyOrders: '15',
      otherLoyaltyOrdersPercent: '15%',
      uniqueUserScan2Pay: '15',
      uniqueUserWeb: '15',
      uniqueUserApp: '15',
      uniqueUserInStore: '15',
      uniqueUserOther: '15',
    },
  ],
  total: {
    newMembers: '20',
    membersWhoOrdered: '32',
    deletedAccounts: '32',
    activeMembers: '32',
    activeMemberPercent: '32%',
    totalOrders: '32',
    loyaltyEarnOrders: '32',
    loyaltyBurnOrders: '32',
    loyaltyNetZeroOrders: '32',
    totalLoyaltyOrders: '32',
    loyaltyContribution: '32%',
    allOrdersNetSales: '$32',
    bonusEarnEvents: '22',
    loyaltyOrdersNetSales: '$32',
    loyaltySales: '$32',
    discountAmount: '$32',
    loyaltyContributionSalesPercent: '32%',
    loyaltyContributionOrdersPercent: '32%',
    loyaltyAverageCheck: '$32',
    mobileLoyaltyOrders: '32',
    mobileLoyaltyOrdersPercent: '32%',
    webLoyaltyOrders: '32',
    webLoyaltyOrdersPercent: '32%',
    scan2PayOrders: '32',
    scan2PayOrdersPercent: '32%',
    inStoreLoyaltyOrders: '32',
    inStoreLoyaltyOrdersPercent: '32%',
    otherLoyaltyOrders: '32',
    otherLoyaltyOrdersPercent: '32%',
    uniqueUserScan2Pay: '32',
    uniqueUserWeb: '32',
    uniqueUserApp: '32',
    uniqueUserInStore: '32',
    uniqueUserOther: '32',
  },
};

export const locationsTrends: LocationsTrends = {
  dataGrid: {
    paging: {
      total: 2,
      count: 10,
      totalPages: 1,
      currentPage: 0,
    },
    stores: [
      {
        storeId: '1',
        displayInfoTitle: 'Location 1',
        data: ['1', '2'],
      },
      {
        storeId: '2',
        displayInfoTitle: 'Location 2',
        data: ['11', '32'],
      },
    ],
    total: ['10', '20'],
  },
  lineChart: {
    series: [
      {
        label: 'lineChart',
        data: [
          4000, 3000, 2000, 2780, 1890, 2390, 3490, 3000, 2000, 2780, 1890,
          2390,
        ],
      },
    ],
    xlabels: [
      '2023-05-29',
      '2023-06-23',
      '2023-07-23',
      '2023-08-23',
      '2023-09-23',
      '2023-10-23',
      '2023-11-23',
      '2023-12-23',
      '2024-01-24',
      '2024-02-24',
      '2024-03-24',
      '2024-04-24',
    ],
  },
};

export const offersPerformanceSummary: OffersPerformanceSummary = {
  loyaltyEarnOrders: {
    value: 0,
    comparisonNumber: 0,
    // sparkLineData: [0],
    cardType: 'number',
  },
  loyaltyBurnOrders: {
    value: 0,
    comparisonNumber: 0,
    // sparkLineData: [0],
    cardType: 'number',
  },
  loyaltyOrdersNetSales: {
    value: 0,
    comparisonNumber: 0,
    // sparkLineData: [0],
    cardType: 'number',
  },
  discountAmount: {
    value: 0,
    comparisonNumber: 0,
    // sparkLineData: [0],
    cardType: 'number',
  },
  activeMembers: {
    value: 0,
    comparisonNumber: 0,
    // sparkLineData: [0],
    cardType: 'number',
  },
};

export const offersPerformanceData: OfferPerformanceData = {
  paging: {
    total: 2,
    count: 10,
    totalPages: 1,
    currentPage: 0,
  },
  offers: [
    {
      offerId: 'Offer 1',
      displayInfoTitle: 'Offer 1',
      newMembers: '1',
      totalMembers: '1',
      deletedAccounts: '1',
      activeMembers: '1',
      activeMemberPercent: '2%',
      totalOrders: '2',
      loyaltyEarnOrders: '2',
      loyaltyBurnOrders: '2',
      loyaltyNetZeroOrders: '2',
      totalLoyaltyOrders: '3',
      loyaltyContribution: '3',
      allOrdersNetSales: '3',
      bonusEarnEvents: '22',
      loyaltyOrdersNetSales: '3',
      loyaltySales: '44',
      discountAmount: '44',
      loyaltyContributionSalesPercent: '44%',
      loyaltyContributionOrdersPercent: '44%',
      loyaltyAverageCheck: '54',
      mobileLoyaltyOrders: '54',
      mobileLoyaltyOrdersPercent: '54%',
      webLoyaltyOrders: '54',
      webLoyaltyOrdersPercent: '54%',
      scan2PayOrders: '54',
      scan2PayOrdersPercent: '66%',
      inStoreLoyaltyOrders: '66',
      inStoreLoyaltyOrdersPercent: '66%',
      otherLoyaltyOrders: '66',
      otherLoyaltyOrdersPercent: '66%',
      uniqueUserScan2Pay: '66',
      uniqueUserWeb: '66',
      uniqueUserApp: '66',
      uniqueUserInStore: '66',
      uniqueUserOther: '66',
      currentStatus: 'ACTIVE',
      offerType: 'Loyalty Point Offer',
      distributionMethod: 'ACTIVITY',
      distributionEndDateType: 'Static',
      redemptionEndDateType: 'Static',
      redemptionEndTime: null,
      redemptionDateRangeStart: '2025-04-22T00:00:00Z',
      redemptionDateRangeEnd: '2035-05-31T00:00:00Z',
      distributionDateRangeStart: '2025-04-22T00:00:00Z',
      distributionDateRangeEnd: '2035-05-31T00:00:00Z',
      redemptionDateRange: 'Apr 22, 2025 to May 31, 2035',
      distributionDateRange: 'Apr 22, 2025 to May 31, 2035',
      averageDaysToRedeem: '0',
      distributionsAllTime: '0',
      distributionsSelectedTimePeriod: '0',
      redemptionsAllTimeDistributions: '0',
      redemptionsSelectedTimePeriodDistributions: '0',
      redemptionRateAllTime: '0.00%',
      redemptionRateDistributedAndRedeemedInPeriod: '0.00%',
      redemptionRateDistributedAllTimeRedeemedInPeriod: '0.00%',
      totalOpened: '0',
      totalDeleted: '0',
      totalSaved: '0',
      averageDiscountPercent: null,
    },
    {
      offerId: 'Offer 2',
      displayInfoTitle: 'Offer 2',
      newMembers: '12',
      totalMembers: '12',
      deletedAccounts: '12',
      activeMembers: '12',
      activeMemberPercent: '23%',
      totalOrders: '23',
      loyaltyEarnOrders: '23',
      loyaltyBurnOrders: '23',
      loyaltyNetZeroOrders: '23',
      totalLoyaltyOrders: '32',
      loyaltyContribution: '32',
      allOrdersNetSales: '32',
      bonusEarnEvents: '22',
      loyaltyOrdersNetSales: '32',
      loyaltySales: '47',
      discountAmount: '47',
      loyaltyContributionSalesPercent: '47%',
      loyaltyContributionOrdersPercent: '47%',
      loyaltyAverageCheck: '55',
      mobileLoyaltyOrders: '55',
      mobileLoyaltyOrdersPercent: '55%',
      webLoyaltyOrders: '55',
      webLoyaltyOrdersPercent: '55%',
      scan2PayOrders: '55',
      scan2PayOrdersPercent: '62%',
      inStoreLoyaltyOrders: '62',
      inStoreLoyaltyOrdersPercent: '62%',
      otherLoyaltyOrders: '62',
      otherLoyaltyOrdersPercent: '62%',
      uniqueUserScan2Pay: '62',
      uniqueUserWeb: '62',
      uniqueUserApp: '62',
      uniqueUserInStore: '62',
      uniqueUserOther: '62',
      currentStatus: 'ACTIVE',
      offerType: 'Loyalty Point Offer',
      distributionMethod: 'ACTIVITY',
      distributionEndDateType: 'Static',
      redemptionEndDateType: 'Static',
      redemptionEndTime: null,
      redemptionDateRangeStart: '2025-04-22T00:00:00Z',
      redemptionDateRangeEnd: '2035-05-31T00:00:00Z',
      distributionDateRangeStart: '2025-04-22T00:00:00Z',
      distributionDateRangeEnd: '2035-05-31T00:00:00Z',
      redemptionDateRange: 'Apr 22, 2025 to May 31, 2035',
      distributionDateRange: 'Apr 22, 2025 to May 31, 2035',
      averageDaysToRedeem: '0',
      distributionsAllTime: '0',
      distributionsSelectedTimePeriod: '0',
      redemptionsAllTimeDistributions: '0',
      redemptionsSelectedTimePeriodDistributions: '0',
      redemptionRateAllTime: '0.00%',
      redemptionRateDistributedAndRedeemedInPeriod: '0.00%',
      redemptionRateDistributedAllTimeRedeemedInPeriod: '0.00%',
      totalOpened: '0',
      totalDeleted: '0',
      totalSaved: '0',
      averageDiscountPercent: null,
    },
  ],
  total: {
    newMembers: '12',
    totalMembers: '12',
    deletedAccounts: '12',
    activeMembers: '12',
    activeMemberPercent: '23%',
    totalOrders: '23',
    loyaltyEarnOrders: '23',
    loyaltyBurnOrders: '23',
    loyaltyNetZeroOrders: '23',
    totalLoyaltyOrders: '32',
    loyaltyContribution: '32',
    allOrdersNetSales: '32',
    bonusEarnEvents: '22',
    loyaltyOrdersNetSales: '32',
    loyaltySales: '47',
    discountAmount: '47',
    loyaltyContributionSalesPercent: '47%',
    loyaltyContributionOrdersPercent: '47%',
    loyaltyAverageCheck: '55',
    mobileLoyaltyOrders: '55',
    mobileLoyaltyOrdersPercent: '55',
    webLoyaltyOrders: '55',
    webLoyaltyOrdersPercent: '55%',
    scan2PayOrders: '55',
    scan2PayOrdersPercent: '62%',
    inStoreLoyaltyOrders: '62',
    inStoreLoyaltyOrdersPercent: '62%',
    otherLoyaltyOrders: '62',
    otherLoyaltyOrdersPercent: '62%',
    uniqueUserScan2Pay: '62',
    uniqueUserWeb: '62',
    uniqueUserApp: '62',
    uniqueUserInStore: '62',
    uniqueUserOther: '62',
    currentStatus: 'ACTIVE',
    offerType: 'Loyalty Point Offer',
    distributionMethod: 'ACTIVITY',
    distributionEndDateType: 'Static',
    redemptionEndDateType: 'Static',
    redemptionEndTime: null,
    redemptionDateRangeStart: '2025-04-22T00:00:00Z',
    redemptionDateRangeEnd: '2035-05-31T00:00:00Z',
    distributionDateRangeStart: '2025-04-22T00:00:00Z',
    distributionDateRangeEnd: '2035-05-31T00:00:00Z',
    redemptionDateRange: 'Apr 22, 2025 to May 31, 2035',
    distributionDateRange: 'Apr 22, 2025 to May 31, 2035',
    averageDaysToRedeem: '0',
    distributionsAllTime: '0',
    distributionsSelectedTimePeriod: '0',
    redemptionsAllTimeDistributions: '0',
    redemptionsSelectedTimePeriodDistributions: '0',
    redemptionRateAllTime: '0.00%',
    redemptionRateDistributedAndRedeemedInPeriod: '0.00%',
    redemptionRateDistributedAllTimeRedeemedInPeriod: '0.00%',
    totalOpened: '0',
    totalDeleted: '0',
    totalSaved: '0',
    averageDiscountPercent: null,
  },
};

export const offersTrends: OfferTrends = {
  dataGrid: {
    paging: {
      total: 2,
      count: 10,
      totalPages: 1,
      currentPage: 0,
    },
    offers: [
      {
        offerId: 'offer 1',
        displayInfoTitle: 'Offer 1',
        data: ['1', '2'],
      },
      {
        offerId: 'offer 2',
        displayInfoTitle: 'Offer 2',
        data: ['1', '2'],
      },
    ],
    total: ['11', '22'],
  },
  lineChart: {
    series: [
      {
        label: 'lineChart',
        data: [
          4000, 3000, 2000, 2780, 1890, 2390, 3490, 3000, 2000, 2780, 1890,
          2390,
        ],
      },
    ],
    xlabels: [
      '2023-05-29',
      '2023-06-23',
      '2023-07-23',
      '2023-08-23',
      '2023-09-23',
      '2023-10-23',
      '2023-11-23',
      '2023-12-23',
      '2024-01-24',
      '2024-02-24',
      '2024-03-24',
      '2024-04-24',
    ],
  },
};

export const franchiseSummary: LoyaltyReportSummaryCard = {
  activeMembers: { value: 1304, comparisonNumber: 0.11, cardType: 'number' },
  activeMembersPercent: {
    value: 1304,
    comparisonNumber: 0.11,
    cardType: 'number',
  },
  systemActiveMembersPercent: {
    value: 0.58,
    comparisonNumber: -0.11,
    cardType: 'percent',
  },
  contributionRate: {
    value: 0.25,
    comparisonNumber: 0.5,
    cardType: 'percent',
  },
  systemContributionRate: {
    value: 0.25,
    comparisonNumber: 0.5,
    cardType: 'percent',
  },
};

export const brandSignupTimeSeries: LineChartResponse = {
  series: [
    {
      data: [
        4000, 3000, 2000, 2780, 1890, 2390, 3490, 3000, 2000, 2780, 1890, 2390,
      ],
      label: 'New Sign Ups',
    },
    {
      data: [
        7900, 1398, 9800, 3908, 4800, 3800, 4300, 9800, 3908, 4800, 3800, 4300,
      ],
      label: 'Active Members',
    },
  ],
  xlabels: [
    '2023-05-29',
    '2023-06-23',
    '2023-07-23',
    '2023-08-23',
    '2023-09-23',
    '2023-10-23',
    '2023-11-23',
    '2023-12-23',
    '2024-01-24',
    '2024-02-24',
    '2024-03-24',
    '2024-04-24',
  ],
};

export const franchiseActiveMembers: LineChartResponse = {
  series: [
    {
      data: [
        4000, 3000, 2000, 2780, 1890, 2390, 3490, 3000, 2000, 2780, 1890, 2390,
      ],
      label: 'System Members',
    },
    {
      data: [
        7900, 1398, 9800, 3908, 4800, 3800, 4300, 9800, 3908, 4800, 3800, 4300,
      ],
      label: 'Active Members',
    },
  ],
  xlabels: [
    '2023-05-29',
    '2023-06-23',
    '2023-07-23',
    '2023-08-23',
    '2023-09-23',
    '2023-10-23',
    '2023-11-23',
    '2023-12-23',
    '2024-01-24',
    '2024-02-24',
    '2024-03-24',
    '2024-04-24',
  ],
};

export const franchiseLoyaltySales: LineChartResponse = {
  series: [
    {
      data: [
        3000, 3000, 2000, 2780, 1890, 2390, 3490, 3000, 2000, 2780, 1890, 2390,
      ],
      label: 'Loyalty Sales',
    },
    {
      data: [
        7900, 1398, 9800, 3908, 4800, 3800, 4300, 9800, 3908, 4800, 3800, 4300,
      ],
      label: 'System Loyalty Sales',
    },
  ],
  xlabels: [
    '2023-05-29',
    '2023-06-23',
    '2023-07-23',
    '2023-08-23',
    '2023-09-23',
    '2023-10-23',
    '2023-11-23',
    '2023-12-23',
    '2024-01-24',
    '2024-02-24',
    '2024-03-24',
    '2024-04-24',
  ],
};

export const brandOrders: PieChartResponse = {
  data: [
    // I don't think we're translating these, so pass like this (not camel case)
    { value: 5, label: 'Scan to Pay' },
    { value: 10, label: 'InStore' },
    { value: 10, label: 'Web Ordering' },
    { value: 10, label: 'Mobile App' },
  ],
};

export const availableOffers: GetAvailableOffersResponse = {
  offers: [
    {
      offerId: '9243f7ee-bae8-4add-b6ec-42d3919c439b',
      offerName: 'Active Auto Offer',
    },
    { offerId: 'offer 2', offerName: 'Offer 2' },
  ],
};

export const brandSignupAggregate: PieChartResponse = {
  data: [
    { value: 5, label: 'Organic Sign Ups' },
    { value: 10, label: 'Referral Sign Ups' },
  ],
};
